(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('bundle-builder')) return;

  function formatMoney(cents, format) {
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var commaSeparator = placeholder.indexOf('comma_separator') !== -1;
    var noDecimals = placeholder.indexOf('no_decimals') !== -1;
    var parts = (cents / 100).toFixed(noDecimals ? 0 : 2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, commaSeparator ? '.' : ',');
    var amount = parts[1] ? whole + (commaSeparator ? ',' : '.') + parts[1] : whole;
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function bundleId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      var data = JSON.parse(this.querySelector('[data-byob-variants]').textContent);
      this.variants = new Map(data.map(function (v) { return [String(v.id), v]; }));

      this.min = Number(this.dataset.min);
      this.max = Number(this.dataset.max);
      this.discount = Number(this.dataset.discount) || 0;
      this.moneyFormat = this.dataset.moneyFormat;

      /* variantId -> quantity */
      this.picks = new Map();

      this.cards = Array.from(this.querySelectorAll('[data-byob-card]'));
      this.listEl = this.querySelector('[data-byob-list]');
      this.placeholderEl = this.querySelector('[data-byob-placeholder]');
      this.progressEl = this.querySelector('[data-byob-progress]');
      this.barEl = this.querySelector('[data-byob-bar]');
      this.subtotalEl = this.querySelector('[data-byob-subtotal]');
      this.savingRowEl = this.querySelector('[data-byob-saving-row]');
      this.savingEl = this.querySelector('[data-byob-saving]');
      this.totalEl = this.querySelector('[data-byob-total]');
      this.submitEl = this.querySelector('[data-byob-submit]');
      this.submitTextEl = this.querySelector('[data-byob-submit-text]');
      this.resetEl = this.querySelector('[data-byob-reset]');
      this.messageEl = this.querySelector('[data-byob-message]');

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', this.handleChange.bind(this));
      this.listEl.addEventListener('click', this.handleRemove.bind(this));
      this.submitEl.addEventListener('click', this.addToCart.bind(this));
      this.resetEl.addEventListener('click', this.reset.bind(this));

      this.render();
    }

    get count() {
      var total = 0;
      this.picks.forEach(function (qty) { total += qty; });
      return total;
    }

    get subtotal() {
      var sum = 0;
      this.picks.forEach(function (qty, id) {
        sum += this.variants.get(id).price * qty;
      }, this);
      return sum;
    }

    cardVariantId(card) {
      return String(card.querySelector('[data-byob-variant]').value);
    }

    add(variantId, amount) {
      var variant = this.variants.get(variantId);
      if (!variant || !variant.available) return;
      if (this.count + amount > this.max) return;
      this.picks.set(variantId, (this.picks.get(variantId) || 0) + amount);
      this.setMessage('');
      this.render();
    }

    remove(variantId, amount) {
      var next = (this.picks.get(variantId) || 0) - amount;
      if (next > 0) this.picks.set(variantId, next);
      else this.picks.delete(variantId);
      this.setMessage('');
      this.render();
    }

    handleClick(event) {
      var card = event.target.closest('[data-byob-card]');
      if (!card) return;
      var variantId = this.cardVariantId(card);
      if (event.target.closest('[data-byob-add]') || event.target.closest('[data-byob-increase]')) {
        this.add(variantId, 1);
      } else if (event.target.closest('[data-byob-decrease]')) {
        this.remove(variantId, 1);
      }
    }

    /* Switching variant carries the quantity across so the customer
       doesn't lose their pick. */
    handleChange(event) {
      var select = event.target.closest('[data-byob-variant]');
      if (!select) return;
      var card = select.closest('[data-byob-card]');
      var previous = card.dataset.activeVariant;
      var next = String(select.value);

      if (previous && previous !== next && this.picks.has(previous)) {
        var qty = this.picks.get(previous);
        this.picks.delete(previous);
        var variant = this.variants.get(next);
        if (variant && variant.available) this.picks.set(next, qty);
      }
      this.render();
    }

    handleRemove(event) {
      var button = event.target.closest('[data-byob-line-remove]');
      if (!button) return;
      var id = button.dataset.byobLineRemove;
      this.remove(id, this.picks.get(id) || 1);
    }

    reset() {
      this.picks.clear();
      this.setMessage('');
      this.render();
    }

    render() {
      var count = this.count;
      var full = count >= this.max;

      this.cards.forEach(function (card) {
        var variantId = this.cardVariantId(card);
        var variant = this.variants.get(variantId);
        var qty = this.picks.get(variantId) || 0;

        card.dataset.activeVariant = variantId;
        card.classList.toggle('is-selected', qty > 0);

        var priceEl = card.querySelector('[data-byob-card-price]');
        if (priceEl && variant) priceEl.textContent = formatMoney(variant.price, this.moneyFormat);

        var addEl = card.querySelector('[data-byob-add]');
        var stepperEl = card.querySelector('[data-byob-stepper]');
        var countEl = card.querySelector('[data-byob-count]');
        var increaseEl = card.querySelector('[data-byob-increase]');

        addEl.hidden = qty > 0;
        stepperEl.hidden = qty === 0;
        countEl.textContent = qty;
        addEl.disabled = !variant || !variant.available || full;
        increaseEl.disabled = full;
      }, this);

      this.renderLines();

      var subtotal = this.subtotal;
      var saving = this.discount > 0 && count >= this.min ? Math.round(subtotal * this.discount / 100) : 0;

      this.subtotalEl.textContent = formatMoney(subtotal, this.moneyFormat);
      this.savingRowEl.hidden = saving === 0;
      this.savingEl.textContent = '\u2212' + formatMoney(saving, this.moneyFormat);
      this.totalEl.textContent = formatMoney(subtotal - saving, this.moneyFormat);

      var remaining = this.min - count;
      if (remaining > 0) {
        this.progressEl.textContent = 'Pick ' + remaining + ' more ' + (remaining === 1 ? 'item' : 'items');
      } else if (full) {
        this.progressEl.textContent = 'Your bundle is full at ' + this.max + ' items';
      } else {
        this.progressEl.textContent = count + ' picked, add up to ' + (this.max - count) + ' more';
      }

      this.barEl.style.transform = 'scaleX(' + Math.min(count / this.min, 1) + ')';
      this.placeholderEl.hidden = count > 0;
      this.resetEl.hidden = count === 0;

      this.submitEl.disabled = count < this.min;
      this.submitTextEl.textContent = count < this.min
        ? 'Pick ' + remaining + ' more to continue'
        : this.dataset.buttonLabel;
    }

    renderLines() {
      this.listEl.textContent = '';
      this.picks.forEach(function (qty, id) {
        var variant = this.variants.get(id);
        var li = document.createElement('li');
        li.className = 'byob-line';

        var media = document.createElement('span');
        media.className = 'byob-line__media';
        if (variant.image) {
          var img = document.createElement('img');
          img.src = variant.image;
          img.alt = '';
          img.loading = 'lazy';
          media.appendChild(img);
        }

        var name = document.createElement('span');
        name.className = 'byob-line__name';
        name.textContent = qty + ' \u00d7 ' + variant.product;
        if (variant.variant && variant.variant !== 'Default Title') {
          var sub = document.createElement('span');
          sub.className = 'byob-line__variant';
          sub.textContent = variant.variant;
          name.appendChild(sub);
        }

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'byob-line__remove';
        remove.dataset.byobLineRemove = id;
        remove.setAttribute('aria-label', 'Remove ' + variant.product + ' from your bundle');
        remove.textContent = '\u00d7';

        li.append(media, name, remove);
        this.listEl.appendChild(li);
      }, this);
    }

    setMessage(text) {
      this.messageEl.textContent = text;
      this.messageEl.hidden = !text;
    }

    async addToCart() {
      if (this.count < this.min) return;

      var properties = { _bundle_id: bundleId() };
      if (this.dataset.bundleLabel) properties.Bundle = this.dataset.bundleLabel;

      var items = [];
      this.picks.forEach(function (qty, id) {
        items.push({ id: Number(id), quantity: qty, properties: properties });
      });

      this.submitEl.classList.add('is-loading');
      this.submitEl.disabled = true;
      this.setMessage('');

      try {
        var response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items: items })
        });
        var data = await response.json();

        if (!response.ok) {
          this.setMessage(data.description || data.message || 'Something in this bundle is no longer available. Swap it out and try again.');
          return;
        }

        document.dispatchEvent(new CustomEvent('bundle-builder:added', { bubbles: true, detail: { items: data.items || [] } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        if (this.dataset.afterAdd === 'cart') {
          window.location.href = this.dataset.cartUrl;
          return;
        }

        this.picks.clear();
        this.setMessage('Bundle added to your cart.');
      } catch (error) {
        this.setMessage('The cart did not respond. Try again in a moment.');
      } finally {
        this.submitEl.classList.remove('is-loading');
        this.render();
      }
    }
  }

  customElements.define('bundle-builder', BundleBuilder);
})();

  } catch(e) { console.error(e); }
})();
})();
